export default {"src":"https://images-cdn-staging.curipod.com/d-e8b4f5f2/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};